import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { IRequest } from "ngxs-requests-plugin";

import { ExtractDownload, ExtractPreview, GetExtractNameFromHash, UpdateExtractName, GetAllQueries, GetQueryDetails } from "../ngxs/extract/extract.actions";
import { ExtractDownloadRequestState, ExtractPreviewRequestState, GetExtractNameFromHashRequestState, GetQueryDetailsRequestState } from "../ngxs/extract/extract.state";
import { ExtractGetterState, QueriesGetterState, QueryGetterState } from "../ngxs/extract/extract-getter.state";

@Injectable({
  providedIn: 'root'
})
export class ExtractService {
  @Select(ExtractPreviewRequestState)
  extractPreviewRequestState$: Observable<IRequest>;

  @Select(ExtractDownloadRequestState)
  extractDownloadRequestState$: Observable<IRequest>;
  
  @Select(GetQueryDetailsRequestState)
  getQueryDetailsRequestState$: Observable<IRequest>;

  @Select(ExtractGetterState.getDownloadIsLoading)
  downloadIsLoading$: Observable<boolean>;

  @Select(ExtractGetterState.getPreviewData)
  previewData$: Observable<any>;

  @Select(ExtractGetterState.getPreviewIsLoading)
  previewIsLoading$: Observable<boolean>;

  @Select(ExtractGetterState.getLoadingMessage)
  loadingMessage$: Observable<string>;

  @Select(ExtractGetterState.getExtractUrl)
  extractUrl$: Observable<string>;

  @Select(ExtractGetterState.getExtractName)
  extractName$: Observable<string>;

  @Select(QueriesGetterState.getQueries)
  queries$: Observable<any>;

  @Select(QueryGetterState.getQuery)
  query$: Observable<any>;

  constructor(
    private store: Store,
  ) {}

  extract(preview: boolean) {
    if (preview) {
      this.store.dispatch(new ExtractPreview());
    } else {
      this.store.dispatch(new ExtractDownload());
    }
  }

  getExtractNameFromHash() {
    this.store.dispatch(new GetExtractNameFromHash());
  }

  updateExtractName(newName: string) {
    // Update extract name in state
    this.store.dispatch(new UpdateExtractName(newName));
    
  }

  getAllQueries() {
    // Get a list of all queries
    this.store.dispatch(new GetAllQueries());
  }

  getQueryDetails(name: string) {
    // Get query details
    this.store.dispatch(new GetQueryDetails(name));
  }
}